(() => {
  if (window.__bfProductBadgesInitialized) return;
  window.__bfProductBadgesInitialized = true;

  const modifierFor = (value) =>
    value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  function buildBadge(value) {
    const badge = document.createElement('span');
    badge.className = `bf-product-badge bf-product-badge--${modifierFor(value)}`;
    badge.setAttribute('aria-label', value === 'HOT' ? 'Hot' : value);

    if (value === 'HOT') {
      const icon = document.createElement('span');
      icon.className = 'bf-product-badge__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '🔥';
      badge.appendChild(icon);
    }

    const text = document.createElement('span');
    text.textContent = value;
    badge.appendChild(text);
    return badge;
  }

  function enhanceCard(card) {
    if (!(card instanceof Element)) return;

    const inner = card.querySelector(':scope > .card > .card__inner');
    const source = card.querySelector('.bf-product-badge-source[data-bf-product-badge]');
    if (!inner) return;

    const existing = inner.querySelector(':scope > .bf-product-badge');
    const value = source?.dataset.bfProductBadge?.trim() || '';

    if (!value) {
      existing?.remove();
      return;
    }

    if (existing?.dataset.badgeValue === value) return;
    existing?.remove();

    const badge = buildBadge(value);
    badge.dataset.badgeValue = value;
    inner.appendChild(badge);
  }

  function scan(root = document) {
    if (root instanceof Element && root.matches('.product-card-wrapper')) enhanceCard(root);
    root.querySelectorAll?.('.product-card-wrapper').forEach(enhanceCard);
  }

  function init() {
    scan(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('bf:catalog:navigated', () => requestAnimationFrame(() => scan(document)));
})();
